import { BIModel } from './BIModel';

export class OfferCreatedBIModel extends BIModel {

    static eventName = 'offer_create';

    #productId;
    #offeredPrice;
    #currentPrice;
    #message;
    #offerId;
    #sellerId;
    #countrySeller;

    constructor(userId, productId, offeredPrice, currentPrice, message, offerId, sellerId, countrySeller) {
        super(OfferCreatedBIModel.eventName, userId);

        this.#productId = productId;
        this.#offeredPrice = offeredPrice;
        this.#currentPrice = currentPrice;
        this.#message = message;
        this.#offerId = offerId;
        this.#sellerId = sellerId;
        this.#countrySeller = countrySeller;
    }

    static createFromDomainEvent(userId, offerCreatedEvent) {
        return new OfferCreatedBIModel(
            userId,
            offerCreatedEvent.productId,
            offerCreatedEvent.offeredPrice,
            offerCreatedEvent.currentPrice,
            offerCreatedEvent.message,
            offerCreatedEvent.offerId,
            offerCreatedEvent.sellerId,
            offerCreatedEvent.countrySeller
        );
    }

    get productId() {
        return this.#productId;
    }

    get offeredPrice() {
        return this.#offeredPrice;
    }

    get currentPrice() {
        return this.#currentPrice;
    }

    get message() {
        return this.#message;
    }

    get offerId() {
        return this.#offerId;
    }

    get sellerId() {
        return this.#sellerId;
    }

    get countrySeller() {
        return this.#countrySeller;
    }

    get modelData() {
        return {
            product_id: this.productId,
            offered_price: this.offeredPrice,
            current_price: this.currentPrice,
            message: this.message,
            offer_id: this.offerId,
            seller_id: this.sellerId,
            country_seller: this.countrySeller
        };
    }

}